export enum CreditReason {
  Discount = 'Discount',
}
